import type { Organization } from "@/shared/api/organizations";

import type { OrganizationData } from "../model/types";

const DEFAULT_AVATAR = "/avatars/default-avatar.svg";
const DEFAULT_BANNER = "/covers/default-cover.svg";

export function mapOrganization(dto: Organization): OrganizationData {
  const pickNonEmptyString = (v: unknown): string | undefined => {
    if (typeof v !== "string") return undefined;
    const trimmed = v.trim();
    return trimmed.length > 0 ? trimmed : undefined;
  };

  const avatarUrl =
    dto.avatarUrl && dto.avatarUrl.trim().length > 0
      ? dto.avatarUrl
      : undefined;
  const bannerUrl =
    dto.bannerUrl && dto.bannerUrl.trim().length > 0
      ? dto.bannerUrl
      : undefined;
  const discordServerId =
    dto.discordServerId && dto.discordServerId.trim().length > 0
      ? dto.discordServerId
      : undefined;
  const url = dto.url && dto.url.trim().length > 0 ? dto.url : dto.id;

  const rawSocialLinks = (dto as { socialLinks?: Record<string, unknown> })
    ?.socialLinks;
  // KAN-203: legacy-плоские поля ссылок — бэк отдаёт их не всегда и вне схемы.
  const legacy = dto as Partial<
    Record<
      | "websiteUrl" | "discordUrl" | "youtubeUrl" | "twitchUrl"
      | "telegramUrl" | "twitterUrl" | "vkUrl",
      string | null
    >
  >;

  return {
    id: dto.id,
    name: dto.name,
    url,
    description: dto.description ?? "",
    avatar: avatarUrl ?? DEFAULT_AVATAR,
    banner: bannerUrl ?? DEFAULT_BANNER,
    avatarUrl,
    bannerUrl,
    memberCount: dto.memberCount ?? 0,
    subscriberCount: dto.subscriberCount ?? 0,
    createdAt: dto.createdAt,
    createdById: dto.ownerId,
    currentUserRole: dto.currentUserRole ?? null,
    discordServerId: discordServerId,
    streamers: dto.streamers ?? [],
    isVerified: Boolean(dto.isVerified ?? false),
    location: "Online",
    socialLinks: {
      website: pickNonEmptyString(
        rawSocialLinks?.["website"] ?? legacy?.websiteUrl,
      ),
      discord: pickNonEmptyString(
        rawSocialLinks?.["discord"] ?? legacy?.discordUrl,
      ),
      youtube: pickNonEmptyString(
        rawSocialLinks?.["youtube"] ?? legacy?.youtubeUrl,
      ),
      twitch: pickNonEmptyString(
        rawSocialLinks?.["twitch"] ?? legacy?.twitchUrl,
      ),
      telegram: pickNonEmptyString(
        rawSocialLinks?.["telegram"] ?? legacy?.telegramUrl,
      ),
      x: pickNonEmptyString(
        rawSocialLinks?.["x"] ?? legacy?.twitterUrl,
      ),
      vk: pickNonEmptyString(
        rawSocialLinks?.["vk"] ?? legacy?.vkUrl,
      ),
    },
    upcomingTournaments: [],
    teamMembers: [],
    stats: {
      totalTournaments: dto.tournamentCount ?? 0,
      activeParticipants: dto.memberCount ?? 0,
      avgParticipants: 0,
      totalViews: 0,
    },
  };
}

export function mapOrganizations(list: Organization[]): OrganizationData[] {
  return list.map(mapOrganization);
}
